import React, { Component } from 'react';
import get from 'lodash/get';
import { connect } from 'react-redux';
import Select from 'react-select';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import moment from 'moment';
import { Tabs, Tab } from 'react-bootstrap';
import { Spinner, DateRange } from '../../../components/common';
import { PublisherApi } from '../../../api';
import { findPredicate, findComparator } from '../../../utils/helpers/filter_conversions';
import { StatBar } from '../../../components/common/';
import { ButtonExport } from '../../../components/common/buttons';
import { calendarRanges } from '../../../utils/helpers/calendar_ranges';

class WebsiteDashboard extends Component {
  state = {
    key: 'text'
  }
  
  componentDidMount() {
    this.fetchResource();
    this.fetchSubIds();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.website.uuid !== this.props.website.uuid) {
      this.fetchResource();
      this.fetchSubIds();
    }
  }

  fetchResource(params = {}) {
    const { website, dispatch } = this.props;
    if (website.uuid) {
      const data = { ...params, publisher_website_id: website.uuid };
      dispatch(PublisherApi.actions.reports.get(data));  
    }
  }

  fetchSubIds() {
    const { website, dispatch } = this.props;
    if (website.uuid) {
      dispatch(PublisherApi.actions.websiteSubIds.get(website.uuid));  
    }
  }

  handleOnFilterChange(e) {
    const filters = get(this.props, 'reports.meta.filters', {});
    Object.entries(e).forEach(([field, properties]) => {
      switch (properties.type) {
        case 'NumberFilter': {
          const { value: { comparator, number } } = properties;
          filters[field] = { value: number, predicate: findPredicate(comparator) };
          break;
        }
        case 'SelectFilter': {
          const { value } = properties;
          filters[field] = { value };
          break;
        }
        default:
          break;
      }
    });

    this.fetchResource({
      page: get(this.props, 'reports.meta.pagination.page', 1),
      per_page: get(this.props, 'reports.meta.pagination.page', 31),
      filters,
      sort: get(this.props, 'reports.meta.sort', {})
    });
  }

  handleOnSortChange(field, order) {
    const sort = { field, order };
    this.fetchResource({
      page: get(this.props, 'reports.meta.pagination.page', 1),
      per_page: get(this.props, 'reports.meta.pagination.page', 31),
      filters: get(this.props, 'reports.meta.filters', {}),
      sort
    });
  }

  handleOnPageChange(page, per_page) {
    this.fetchResource({
      page,
      per_page,
      filters: get(this.props, 'reports.meta.filters', {}),
      sort: get(this.props, 'reports.meta.sort', {})
    });
  }

  handleDateApply(d) {
    const filters = get(this.props, 'reports.meta.filters', {});
    
    filters.daterange = {
      start_date: { value: d.startDate.format() },
      end_date: { value: d.endDate.format() }
    };

    this.fetchResource({
      page: get(this.props, 'reports.meta.pagination.page', 1),
      per_page: get(this.props, 'reports.meta.pagination.page', 31),
      filters,
      sort: get(this.props, 'reports.meta.sort', {})
    });
  }

  generateFilter(dataField) {
    const { value, predicate } = get(this.props, `reports.meta.filters.${dataField}`, {});
    let filter = {};
    switch (dataField) {
      case 'earned':
      case 'video_earned':
      case 'conversions':
      case 'acpa':
      case 'acpc':
      case 'acpv':
      case 'clicks':
      case 'impressions':
      case 'video_views': {
        filter.type = 'NumberFilter';
        filter.numberComparators = ['=', '>', '<'];
        filter.defaultValue = {};
        if (value && predicate) { 
          filter.defaultValue = { 
            number: Number(value), 
            comparator: findComparator(predicate) 
          };
        }
        break;
      }
      case 'report_type': {
        filter.type = 'SelectFilter'; 
        filter.options = {
          cpc: 'cpc',
          cpa: 'cpa'
        };
        filter.defaultValue = 'cpc';
        break;
      }
      case 'network_type': {
        filter.type = 'SelectFilter'; 
        filter.options = {
          all: 'all',
          email: 'email',
          website: 'website'
        };
        filter.defaultValue = 'all';
        break;
      }
      default:
        filter = {};
    }
    return filter;
  }

  generatePerPageList(totalRecords, increment) {
    const numberOfIterations = Math.floor(totalRecords / increment);
    const sizePerPageList = [];

    for (let i = 0; i < numberOfIterations; i++) {
      const incrementValue = increment + (i * increment);
      sizePerPageList.push({ text: incrementValue, value: incrementValue });
    }
    sizePerPageList.push(
      { text: 'All', value: totalRecords }
    );
    return sizePerPageList;
  }

  render() {
    const { reports, isLoading, subIds } = this.props;
    const { data: rawData, meta } = reports || {};
    const { sort } = meta || {};

    const totalData = rawData || [];

    const data = totalData.filter((item) => {
      return item.ad_format === this.state.key;
    });

    const sd = get(meta, 
      'filters.daterange.start_date.value', moment().startOf('month').toISOString());
    const ed = get(meta, 
      'filters.daterange.end_date.value', moment().endOf('month').toISOString());

    const daterange = { start_date: sd, end_date: ed };
    
    const totalCount = data.length;

    const perPageList = this.generatePerPageList(totalCount, 31);

    const ExportCSVButton = (onClick) => {
      return (
        <ButtonExport 
          onClick={onClick}
          className='m-b-sm'
          btnLabel='Export to CSV'
        />
      );
    };
    
    const options = {
      exportCSVBtn: ExportCSVButton,
      onFilterChange: this.handleOnFilterChange.bind(this),
      onSortChange: this.handleOnSortChange.bind(this),
      sortName: get(sort, 'field', 'day'),
      sortOrder: get(sort, 'order', 'asc'),
      defaultSortName: get(sort, 'field', 'day'),
      defaultSortOrder: get(sort, 'order', 'asc'),
      sizePerPageList: perPageList,
      sizePerPage: perPageList[0].value
    };

    const colSum = (tableData, field, dataType) => {
      const filters = get(this.props, 'reports.meta.filters', {});
      if (get(filters, 'report_type.value', 'cpc') === 'cpc' && field === 'conversions') {
        return 'N/A';
      }
      let label = 0;
      for (let i = 0, tableDataLen = tableData.length; i < tableDataLen; i++) {
        label += parseFloat(tableData[i][field]);
      }
      return (
        <strong>{ dataType === 'integer' ? Number(label) : label.toFixed(2) }</strong>
      );
    };

    const colAvg = (tableData, field, ac = 'earned') => {
      const filters = get(this.props, 'reports.meta.filters', {});
      if (get(filters, 'report_type.value', 'cpc') === 'cpc' && field === 'conversions') {
        return 'N/A';
      }
      let earn = 0;
      for (let i = 0, tableDataLen = tableData.length; i < tableDataLen; i++) {
        earn += parseFloat(tableData[i][ac]);
      }

      let typeVal = 0;
      for (let i = 0, tableDataLen = tableData.length; i < tableDataLen; i++) {
        typeVal += parseFloat(tableData[i][field]);
      }

      const label = typeVal === 0 ? 0 : (earn / typeVal);

      return (
        <strong>{ label.toFixed(2) }</strong>
      );
    };

    const footerData = [
      [
        {
          label: 'Total',
          columnIndex: 0
        },
        {
          columnIndex: 4,
          align: 'left',
          formatter: (e) => colSum(e, 'earned')
        },
        {
          columnIndex: 5,
          align: 'left',
          formatter: (e) => colSum(e, 'video_earned')
        },
        {
          columnIndex: 6,
          align: 'left',
          formatter: (e) => colSum(e, 'total_earned')
        },
        {
          columnIndex: 7,
          align: 'left',
          formatter: (e) => colSum(e, 'clicks', 'integer')
        },
        {
          columnIndex: 8,
          align: 'left',
          formatter: (e) => colSum(e, 'video_views', 'integer')
        },
        {
          columnIndex: 9,
          align: 'left',
          formatter: (e) => colSum(e, 'impressions', 'integer')
        },
        {
          columnIndex: 10,
          align: 'left',
          formatter: (e) => colSum(e, 'conversions', 'integer')
        },
        {
          columnIndex: 11,
          align: 'left',
          formatter: (e) => colAvg(e, 'clicks')
        },
        {
          columnIndex: 12,
          align: 'left',
          formatter: (e) => colAvg(e, 'video_views', 'video_earned')
        },
        {
          columnIndex: 13,
          align: 'left',
          formatter: (e) => colAvg(e, 'conversions')
        }
      ]
    ];

    const table = () => {
      return (
        <BootstrapTable
          exportCSV
          csvFileName={`website-earnings-report-${this.state.key}.csv`} 
          striped
          ref={`ReportsTable${this.state.key}`} 
          data={data || []}
          footerData={footerData}
          footer 
          pagination
          options={options}
        >
          <TableHeaderColumn 
            width='120'
            dataSort
            csvHeader='Date' 
            dataField='day'
            dataFormat={(c) => moment(c).local().format('MMMM Do[,] YYYY')}
          >
            Date
          </TableHeaderColumn>

          <TableHeaderColumn 
            width='75'
            dataSort
            csvHeader='Report Type'  
            dataField='report_type' 
            dataFormat={(c) => c}
          >
            Type
          </TableHeaderColumn>

          <TableHeaderColumn 
            width='75'
            dataSort
            csvHeader='Network'  
            dataField='network_type' 
            dataFormat={(c) => c}
          >
            Network
          </TableHeaderColumn>

          <TableHeaderColumn 
            width='180'
            dataSort
            csvHeader='SubID'  
            dataField='sub_id' 
            dataFormat={(c) => c}
            hidden={subIds.length === 0}
          >
            SubID
          </TableHeaderColumn>

          <TableHeaderColumn 
            width='75'
            dataSort
            csvHeader='$ Click Earnings'  
            dataField='earned' 
            dataFormat={(c) => c}
          >
            $ Click <br /> Earnings
          </TableHeaderColumn>

          <TableHeaderColumn 
            width='100'
            dataSort
            csvHeader='$ View Earnings'  
            dataField='video_earned' 
            dataFormat={(c) => c}
            hidden={this.state.key !== 'video'}
          >
            $ Video View <br /> Earnings
          </TableHeaderColumn>

          <TableHeaderColumn 
            width='75'
            csvHeader='$ Total Earnings'  
            dataField='total_earned' 
            dataFormat={(c) => c}
            hidden={this.state.key !== 'video'}
          >
            $ Total <br /> Earnings
          </TableHeaderColumn>

          <TableHeaderColumn 
            width='75'
            dataSort
            csvHeader='Clicks'  
            dataField='clicks' 
            dataFormat={(c) => c}
          >
            Clicks
          </TableHeaderColumn>

          <TableHeaderColumn 
            width='75'
            dataSort
            csvHeader='Views' 
            dataField='video_views' 
            dataFormat={(c) => c}
            hidden={this.state.key !== 'video'}
          >
            Video <br /> Views
          </TableHeaderColumn> 
          
          <TableHeaderColumn 
            width='100'
            dataSort
            csvHeader='Impressions' 
            dataField='impressions' 
            dataFormat={(c) => c}
          >
            Impressions
          </TableHeaderColumn>

          <TableHeaderColumn 
            width='100'
            dataSort
            csvHeader='Conversions' 
            dataField='conversions' 
            dataFormat={(c, r) => {
              return r.report_type === 'cpc' ? 'N/A' : c;
            }}
          >
            Conversions
          </TableHeaderColumn>

          <TableHeaderColumn 
            width='100'
            dataSort
            csvHeader='Average CPC' 
            dataField='acpc' 
            dataFormat={(c) => c}
          >
            Avg. CPC
          </TableHeaderColumn>

          <TableHeaderColumn 
            width='100'
            dataSort
            csvHeader='Average CPV' 
            dataField='acpv'
            dataFormat={(c) => c}
            hidden={this.state.key !== 'video'}
          >
            Avg. CPV
          </TableHeaderColumn>

          <TableHeaderColumn 
            width='100'
            dataSort
            csvHeader='Average CPA' 
            dataField='acpa' 
            dataFormat={(c, r) => {
              return r.report_type === 'cpc' ? 'N/A' : c;
            }}
          >
            Avg. CPA
          </TableHeaderColumn>

          <TableHeaderColumn 
            isKey
            hidden
            width='0'
            dataField='id'
          />   

        </BootstrapTable>
      );
    };

    return (
      <div className='ibox'>
        <div className='ibox-title'>
          <div className='ibox-tools row'>
            <div className="col-sm-12 col-md-1">
              <h5>Report</h5>
            </div>
            <div className="col-sm-12 col-md-11">
              <div className="form-inline">
                <Select
                  value={get(reports, 'meta.filters.network_type.value', 'all')}
                  options={[
                    { value: 'all', label: 'All' },
                    { value: 'email', label: 'Email' },
                    { value: 'website', label: 'Website' }
                  ]}
                  placeholder="Network type"
                  onChange={(e) => {
                    const v = { network_type: { value: (e || {}).value, type: 'SelectFilter' } };
                    this.handleOnFilterChange(v);
                  }}
                  className="ibox-tools-select form-group"
                />
                <Select
                  value={get(reports, 'meta.filters.report_type.value', 'cpc')}
                  options={[
                    { value: 'cpc', label: 'CPC' },
                    { value: 'cpa', label: 'CPA' }
                  ]}
                  placeholder="Report type"
                  onChange={(e) => {
                    const v = { report_type: { value: (e || {}).value, type: 'SelectFilter' } };
                    this.handleOnFilterChange(v);
                  }}
                  className="ibox-tools-select form-group"
                />
                {subIds.length > 0 ? <Select
                  value={get(reports, 'meta.filters.publisher_sub_id.value', null)}
                  options={subIds}
                  placeholder="SubID"
                  onChange={(e) => {
                    const v = { publisher_sub_id: { value: (e || {}).value, type: 'SelectFilter' } };
                    this.handleOnFilterChange(v);
                  }}
                  className="ibox-tools-select form-group"
                /> : null }
                <div className="form-group ibox-tools-select">
                  <DateRange
                    key='daterange-all-reports'
                    defaultChosenLabel='This Month'
                    opens='left' 
                    startDate={moment(daterange.start_date)} 
                    endDate={moment(daterange.end_date)} 
                    ranges={calendarRanges} 
                    onApply={this.handleDateApply.bind(this)}
                  />
                </div>
              </div>
            </div>
          </div>      
        </div>
        <div className={`ibox-content${isLoading ? ' sk-loading' : ''}`}>
          <Spinner />
          <div className='row'>
            <StatBar
              label='Total Earnings'
              value={colSum(totalData, 'total_earned')}
              column='col-lg-3 col-md-4 col-sm-6 col-xs-12'
            />
            <StatBar
              label='Click Earnings'
              value={colSum(totalData, 'earned')}
              column='col-lg-3 col-md-4 col-sm-6 col-xs-12'
            />
            <StatBar
              label='Video View Earnings'
              value={colSum(totalData, 'video_earned')}
              column='col-lg-3 col-md-4 col-sm-6 col-xs-12'
            />
            <StatBar
              label='Clicks'
              value={colSum(totalData, 'clicks', 'integer')}
              column='col-lg-3 col-md-4 col-sm-6 col-xs-12'
            />
            <StatBar
              label='Video Views'
              value={colSum(totalData, 'video_views', 'integer')}
              column='col-lg-3 col-md-4 col-sm-6 col-xs-12'
            />
            <StatBar
              label='Impressions'
              value={colSum(totalData, 'impressions', 'integer')}
              column='col-lg-3 col-md-4 col-sm-6 col-xs-12'
            />
            <StatBar
              label='Conversions'
              value={colSum(totalData, 'conversions', 'integer')}
              column='col-lg-3 col-md-4 col-sm-6 col-xs-12'
            />
            <StatBar
              label='Avg. CPC'
              value={colAvg(totalData, 'clicks')}
              column='col-lg-3 col-md-4 col-sm-6 col-xs-12'
            />
            <StatBar
              label='Avg. CPV'
              value={colAvg(totalData, 'video_views', 'video_earned')}
              column='col-lg-3 col-md-4 col-sm-6 col-xs-12'
            />
            <StatBar
              label='Avg. CPA'
              value={colAvg(totalData, 'conversions')}
              column='col-lg-3 col-md-4 col-sm-6 col-xs-12'
            />
          </div>
          <Tabs
            activeKey={this.state.key}
            onSelect={(key) => this.setState({ key })}
            id="controlled-tab"
          >
            <Tab unmountOnExit eventKey='text' title="Text Ads" className='p-md'>
              {table()}
            </Tab>
            <Tab unmountOnExit eventKey='video' title="Video Ads" className='p-md'>
              {table()}
            </Tab>
          </Tabs>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { publisher: { reports, websites, websiteSubIds } } = state;
  const { params: { websiteName } } = ownProps;
  const website = (websites.data.data || [])
    .filter((w) => w.slug === websiteName)[0] || {};

  return { reports: reports.data, isLoading: reports.loading, website, subIds: get(websiteSubIds, 'data.data', []) };
};

export default connect(mapStateToProps)(WebsiteDashboard);
